import { Loader2Icon } from 'lucide-react'
import type * as React from 'react'

import { cn } from '../../lib/utils'

function Spinner({ className, ...props }: React.ComponentProps<'svg'>) {
  return (
    <Loader2Icon
      role="status"
      aria-label="Carregando"
      className={cn('size-4 animate-spin', className)}
      {...(props as React.ComponentProps<typeof Loader2Icon>)}
    />
  )
}

export { Spinner }
